import React from 'react';
import AboutMe from '../components/Sections/AboutMe';
import { NavBar, HeroSection, CaseStudies, WorkTimeline, Skills, Achievements, Footer, QuizSection } from '../components';
import { ProblemsSection, SummarySection, FounderStrengthsSection } from '../components/Sections';

const Home = () => {

  return (
    <div className="min-h-screen bg-white">
      <NavBar />
      <HeroSection />
      <ProblemsSection />
      <SummarySection />
      <FounderStrengthsSection />
      <QuizSection />
      <CaseStudies />
      <Skills />
      <WorkTimeline />
      <Achievements />
      <AboutMe />
      <Footer />
    </div>
  );
};

export default Home;